import React from 'react';
import loadingImage from '../../images/loading.png';

/**
 * 现代简洁液体效果Loading图标组件
 * 采用现代审美设计，简洁流畅的液体动效
 */
const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <defs>
      {/* 定义圆形裁剪路径 - 保持图像尺寸不变 */}
      <clipPath id="circleClip">
        <circle cx="50" cy="50" r="26" />
      </clipPath>

      {/* 现代液体渐变 - 增加亮白色调 */}
      <linearGradient id="liquidGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="20%" stopColor="#667eea" />
        <stop offset="50%" stopColor="#764ba2" />
        <stop offset="80%" stopColor="#f093fb" />
        <stop offset="100%" stopColor="#ffffff" />
      </linearGradient>

      {/* 液体流动渐变 - 增加亮白色调 */}
      <linearGradient id="flowingGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.5" />
        <stop offset="25%" stopColor="#667eea" stopOpacity="0.4" />
        <stop offset="50%" stopColor="#764ba2" stopOpacity="1" />
        <stop offset="75%" stopColor="#f093fb" stopOpacity="0.4" />
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0.5" />
        <animateTransform
          attributeName="gradientTransform"
          attributeType="XML"
          type="translate"
          values="-100,0;100,0;-100,0"
          dur="2s"
          repeatCount="indefinite"
        />
      </linearGradient>

      {/* 现代发光效果 */}
      <filter id="modernGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="3" result="glow" />
        <feMerge>
          <feMergeNode in="glow" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>

      {/* 液体波动效果 */}
      <filter id="liquidWave" x="-20%" y="-20%" width="140%" height="140%">
        <feTurbulence baseFrequency="0.02" numOctaves="3" result="noise">
          <animate
            attributeName="baseFrequency"
            values="0.02;0.05;0.02"
            dur="4s"
            repeatCount="indefinite"
          />
        </feTurbulence>
        <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
      </filter>
    </defs>

    <g>
      {/* 背景圆环 - 再扩大4像素 */}
      <circle
        cx="50"
        cy="50"
        r="33"
        fill="none"
        stroke="rgba(255, 255, 255, 0.1)"
        strokeWidth="1"
      />

      {/* 图片填充的圆形，使用裁剪路径 - 保持图像尺寸不变 */}
      <g id="B">
        <image
          href={loadingImage}
          x="24"
          y="24"
          width="52"
          height="52"
          preserveAspectRatio="xMidYMid meet"
          clipPath="url(#circleClip)"
        />
      </g>

      {/* 主液体进度条 - 再扩大4像素，线条加粗1像素 */}
      <circle
        cx="50"
        cy="50"
        r="33"
        fill="none"
        stroke="url(#liquidGradient)"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="207.35"
        strokeDashoffset="207.35"
        filter="url(#modernGlow)"
        transform="rotate(-90 50 50)"
      />

      {/* 液体流动效果层 - 再扩大4像素，线条加粗1像素 */}
      <circle
        cx="50"
        cy="50"
        r="33"
        fill="none"
        stroke="url(#flowingGradient)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="207.35"
        strokeDashoffset="207.35"
        opacity="0.6"
        transform="rotate(-90 50 50)"
        filter="url(#liquidWave)"
      />

      {/* 外轮廓液体效果 */}
      <circle
        cx="50"
        cy="50"
        r="38"
        fill="none"
        stroke="url(#flowingGradient)"
        strokeWidth="1"
        opacity="0.4"
        strokeDasharray="4 8"
        filter="url(#liquidWave)">
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          dur="8s"
          repeatCount="indefinite"
        />
      </circle>
    </g>
  </svg>
);

export default IconLoader;
